import {
  isRequiredEmail,
  isRequiredMobileNumber,
  isRequiredNumberGreaterThan0,
  isRequiredString,
} from 'core/utils/validationSchemas';
import * as Yup from 'yup';

// Added enableEdit as the second parameter (defaulting to empty object to prevent crashes)
const staffSchema = (action: string | undefined, enableEdit: any = {}) => {
  
  // Helper to determine if a field is required:
  // If we are NOT updating (creating), it's always required.
  // If we ARE updating, it's only required if the toggle is TRUE.
  const isFieldRequired = (fieldName: string) => {
    return action !== 'update' || enableEdit[fieldName];
  };

  return Yup.object({
    FIRST_NAME: isRequiredString('Staff Name is a required field.'),
    GENDER: isRequiredString('Gender is a required field'),
    LANGUAGE_ID: isRequiredNumberGreaterThan0(
      'Language is a required field',
      'Language is a required field',
    ),
    
    // --- CONDITIONALLY REQUIRED FIELDS ---
    MOBILE_NUMBER: enableEdit.MOBILE_NUMBER 
      ? Yup.string().required("Mobile Number is required") 
      : Yup.string().nullable().notRequired(),

    // ONLY validate match if editing is enabled
    CONFIRM_MOBILE_NUMBER: enableEdit.MOBILE_NUMBER
      ? Yup.string()
          .required("Confirm Mobile Number is required")
          .oneOf([Yup.ref('MOBILE_NUMBER')], 'Mobile numbers must match')
      : Yup.string().nullable().notRequired(),

    EMAIL_ID: isFieldRequired('EMAIL_ID')
      ? isRequiredEmail('Email is a required field', true)
      : Yup.string().nullable().notRequired(),

    AADHAR_NUMBER: isFieldRequired('AADHAR_NUMBER')
      ? Yup.string().nullable() // Add actual required logic here if you want it mandatory on creation
      : Yup.string().nullable().notRequired(),
    // -------------------------------------
     
    PINCODE: isRequiredNumberGreaterThan0(
      'Pin Code is a required field',
      'Pin Code is a required field',
    ),

    CONFIRM_COUNTRY_CODE: (action !== 'update' || enableEdit.MOBILE_NUMBER)
  ? Yup.string()
      .required('Confirm Country Code is required')
      .test('match-country-code', 'Country Code must match', function (value) {
        const countryCode = this.parent.COUNTRY_CODE || '';

        const stripPlus = (val: string) => val.replace(/^\+/, '');
        
        const normalizedConfirm = stripPlus(value || '');
        const normalizedOriginal = stripPlus(countryCode);

        return normalizedConfirm === normalizedOriginal;
      })
  : Yup.string().nullable().notRequired(),
    TEACHING_SINCE: Yup.string().matches(/^[0-9]{4}$/, 'Invalid teaching since. Please enter a valid 4-digit teaching since').required(),
    QUALIFICATION: isRequiredString('Qualification is a required field'),
    CITY_ID: isRequiredNumberGreaterThan0(
      'City is a required field',
      'City is a required field',
    ),
    BIRTH_DATE: isRequiredString('Birth Date is a required field'),
    JOINING_DATE: isRequiredString('Joining Date is a required field'),
    STAFF_ROLES: Yup.array().min(
      !action ? 1 : 0,
      'Select atleast one staff role',
    ),
    ADDRESS: isRequiredString('Address is a required Field'),
  });
};

export default staffSchema;